import type { AppDispatch } from 'mastodon/store';

import api from '../api';

import { showAlertForError } from './alerts';

export type ColorScheme = 'auto' | 'light' | 'dark';

export const changeColorScheme =
  (colorScheme: ColorScheme) => (dispatch: AppDispatch) => {
    api()
      .put('/api/web/color_scheme', { color_scheme: colorScheme })
      .catch((error: unknown) => {
        dispatch(showAlertForError(error));
      });
  };
